var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.611-3.441a3.02,3.02,0,0,0-2.125-2.125c-1.886-.516-9.433-.516-9.433-.516s-7.546,0-9.432.5A3.081,3.081,0,0,0,.5-3.441a31.823,31.823,0,0,0-.5,5.8,31.706,31.706,0,0,0,.5,5.8,3.021,3.021,0,0,0,2.125,2.125c1.906.516,9.432.516,9.432.516s7.546,0,9.432-.5a3.02,3.02,0,0,0,2.125-2.125,31.833,31.833,0,0,0,.5-5.8A30.209,30.209,0,0,0,23.611-3.441ZM9.651,5.972V-1.257l6.275,3.614Zm0,0","transform":"translate(0 6.082)"}));
}

Youtube.defaultProps = {"width":"24.107","height":"16.879","fill":"currentColor","viewBox":"0 0 24.107 16.879"};

module.exports = Youtube;

Youtube.default = Youtube;
